import React from 'react';
import { Reveal } from '../Reveal';
import { SectionEyebrow } from '../SectionEyebrow';
import { CheckIcon } from 'lucide-react';
const items = ['Sienten que necesitan recuperar dirección.', 'Quieren vivir con más equilibrio emocional.', 'Buscan claridad en una etapa de cambio.', 'Desean fortalecer su disciplina sin maltratarse.', 'Quieren reconectar con su cuerpo, mente y espíritu.', 'Están buscando una guía reflexiva de crecimiento personal.', 'Quieren entender mejor sus emociones.', 'Sienten que su intuición y propósito necesitan más espacio.', 'Desean vivir con más coherencia, calma y plenitud.'];
export const WhoFor: React.FC = () => <section className="relative py-28 lg:py-44 overflow-hidden" style={{
  background: 'linear-gradient(180deg, #F5EFE6 0%, #EFE3CC 50%, #E8DCC4 100%)'
}} data-id="element-419">
    <div className="absolute inset-0 opacity-50" style={{
    backgroundImage: 'radial-gradient(circle at 20% 10%, rgba(229,200,150,0.4), transparent 50%),' + 'radial-gradient(circle at 80% 90%, rgba(212,175,122,0.18), transparent 50%)'
  }} data-id="element-420" />

    <div className="relative max-w-5xl mx-auto px-6 lg:px-8" data-id="element-421">
      <div className="text-center mb-16" data-id="element-422">
        <Reveal data-id="element-423">
          <SectionEyebrow light data-id="element-424">Para quién</SectionEyebrow>
        </Reveal>
        <Reveal delay={0.1} data-id="element-425">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-navy-deep leading-[1.1]" style={{
          fontWeight: 300
        }} data-id="element-426">
            Este libro es{' '}
            <span className="italic" style={{
            fontWeight: 400
          }} data-id="element-427">
              para ti
            </span>{' '}
            si...
          </h2>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6" data-id="element-428">
        {items.map((item, i) => <Reveal key={item} delay={i * 0.04} data-id="element-429">
            <div className="bg-white/70 backdrop-blur-sm border border-gold-deep/20 rounded-xl p-5 lg:p-6 flex items-start gap-4 h-full transition-all duration-500 hover:bg-white hover:border-gold-deep/40 hover:shadow-[0_15px_40px_-15px_rgba(184,147,94,0.3)]" data-id="element-430">
              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
            background: 'linear-gradient(135deg, #E5C896, #B8935E)'
          }} data-id="element-431">
                <CheckIcon className="w-4 h-4 text-navy-deep" strokeWidth={2.5} data-id="element-432" />
              </div>
              <p className="text-navy-deep/85 leading-relaxed text-[15px] font-light" data-id="element-433">
                {item}
              </p>
            </div>
          </Reveal>)}
      </div>
    </div>
  </section>;